// extracted by mini-css-extract-plugin
export default {"Header_basic":"Header_Header_basic__rufBQ","Header_external":"Header_Header_external__3frNT","Buttons":"Header_Buttons__Nvhui","Logo":"Header_Logo__9D1fK"};